import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 24px;
  height: 24px;
  color: var(--wg-green);
`

function CheckFilled({ title = 'Check', ...rest }: IconProps) {
  return (
    <StyledIcon viewBox="0 0 24 24" title={title} {...rest}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M12,9.09494702e-13 C5.372583,9.09494702e-13 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9807773,5.38056166 18.6194383,0.0192227178 12,9.09494702e-13 Z M10,17.414 L4.586,12 L6,10.586 L10,14.586 L18,6.586 L19.414,8 L10,17.414 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </StyledIcon>
  )
}

CheckFilled.needsWork = true
export default CheckFilled
